/*import*/
import Desvg from './modules/desvg';
import ObjectFitImages from './modules/object-fit-images';
import InnerScroll from './modules/inner-scroll';
import picturefill from "picturefill";
import Spmenu from './modules/spmenu';
import Toggle from './modules/toggle';
import Header from './modules/header';

class Main {
  constructor() {
    this.setup();
  }
  setup() {
    document.addEventListener('DOMContentLoaded', () => {
      picturefill();

      const spmenu = new Spmenu();
      spmenu.init();

      new Header();

      const footerNavToggle = new Toggle('.l-footerNav__toggleBtn');
      footerNavToggle.toggleNext();

      const spMenuToggle = new Toggle('.js-toggleBtn a');
      spMenuToggle.toggleNext();

    })

    $(window).on('load', () => {
      const innerScroll = new InnerScroll();
      innerScroll.init();
      const desvg = new Desvg();
      desvg.init();

      const isIE = () => {
        let userAgent = window.navigator.userAgent.toLowerCase();
        if ( userAgent.indexOf( 'msie' ) !== -1 || userAgent.indexOf( 'trident' ) !== -1 ) {
            return true;
        }
        return false;
      }

      if (isIE()) {
        const objectFitImages = new ObjectFitImages('img.object-fit');
        objectFitImages.init();
      }

    })
  }
}

export default new Main();
